import { jsx as _jsx } from "react/jsx-runtime";
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { _className } from '@nu-art/thunderstorm-frontend/index';
import { PanelKey_ProvideInfo } from '../../../_shared.js';
import './AdvisorPanel_ProvideInfo.scss';
import { contextCloseMode_Safe } from '../../../modules/provide-info/types.js';
import { ModuleFE_ProvideInfo } from '../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import { Component_ProvideInfo_V2 } from '../../components/provide-info-v2/body/Component_ProvideInfoV2/Component_ProvideInfo_V2.js';
import { Component_ProvideInfoHeader } from '../../components/provide-info-v2/header/Component_ProvideInfoHeader/Component_ProvideInfoHeader.js';
import { ICONS } from '@app/styles';
export class AdvisorPanel_ProvideInfo extends AdvisorPanel {
    static defaultProps = {
        panelKey: PanelKey_ProvideInfo,
    };
    //######################### Logic #########################
    //Triggered when the current context is updated
    __onProvideInfoContextUpdate = (context) => this.forceUpdate();
    //Triggered when the current context is changed
    __onProvideInfoContextChange = (latestContext) => {
        //Force state to assign new context and re-render
        //@ts-ignore;
        this.state.latestContext = ModuleFE_ProvideInfo.getLatestContext();
        //@ts-ignore;
        this.state.baseContext = ModuleFE_ProvideInfo.getBaseContext();
        this.forceUpdate();
    };
    getPanelClass() {
        return _className(super.getPanelClass(), 'panel__provide-info');
    }
    componentDidMount() {
        const latestContext = ModuleFE_ProvideInfo.getLatestContext();
        if (!latestContext)
            return;
        const baseContext = ModuleFE_ProvideInfo.getBaseContext();
        //Force state to assign new context and re-render
        //@ts-ignore;
        this.state.latestContext = latestContext;
        //@ts-ignore;
        this.state.baseContext = baseContext;
        this.forceUpdate();
    }
    //######################### Render - Header #########################
    renderHeader_Title = () => {
        return _jsx(Component_ProvideInfoHeader, { context: this.state.baseContext });
    };
    renderHeader_Tail = () => {
        return _jsx(ICONS.advisor_avn_close.component, { onClick: () => {
                ModuleFE_ProvideInfo.context.chain.close(contextCloseMode_Safe);
            } });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = undefined;
    //######################### Render - Content #########################
    _renderContent(scrollRef) {
        return _jsx(Component_ProvideInfo_V2, { context: this.state.latestContext });
    }
    renderContent = () => undefined;
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorPanel_ProvideInfo.js.map